import { useCallback } from "react";
import {
  CurrentActionTypes,
  useSetPosOrderCurrentAction,
} from "@/shared/atoms/usePosOrderCurrentAction";
import { PosMenuAction } from "../PosMenu/PosMenuBottomActionButton";
import useDefaultAction from "./useDefaultAction";

const useActionClick = (action: PosMenuAction) => {
  const setCurrentAction = useSetPosOrderCurrentAction();
  const setDefaultAction = useDefaultAction();

  return useCallback(() => {
    if (action.disabled) return;
    if (action.instantSet) {
      action.set();
      setDefaultAction();
      return;
    }

    setCurrentAction({
      name: action.name as CurrentActionTypes,
      action: (value: any) => {
        action.set(value);
        setDefaultAction();
      },
    });
  }, [action, setDefaultAction, setCurrentAction]);
};

export default useActionClick;
